import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { MobileHeader, ModalRow, theme } from '@sg/garnish';
import type { Credit } from '@sg/graphql-schema';

import { CreditsList } from '../components/';

export const AvailableCredit = ({
  creditAmount,
  creditDetails,
}: AvailableCreditProps) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <View style={styles.mobileHeaderPadding}>
        <MobileHeader
          title={formatMessage(messages.accountCreditMobileLabel)}
        />
      </View>

      <ModalRow>
        <CreditsList
          credits={creditDetails}
          totalCreditsAmount={creditAmount}
        />
      </ModalRow>
    </>
  );
};

type AvailableCreditProps = Readonly<{
  creditAmount: number;
  creditDetails: readonly Credit[];
}>;

const styles = StyleSheet.create({
  mobileHeaderPadding: {
    paddingTop: theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountCreditMobileLabel: {
    defaultMessage: 'Available credit',
    description: 'Account | Credit | Mobile Label',
  },
});
